import { string } from "yup";

export const EmailValidation = string()
  .trim()
  .email("A valid email is required")
  .matches(/^[\w-+*/=^_~.]+@([\w-]+\.)+[\w-]{2,}$/, { message: "A valid email is required", excludeEmptyString: true })
  .lowercase();
